// ADR-012 i18n — "mySettings" cluster label catalog (My Settings page, WS3
// Feature 2 — per-user preferences, every role). Spread into the central
// LABELS in labels.ts.
export const MY_SETTINGS_LABELS = {
  // ═══════════════════════════════════════════════════════════════════════
  //  Header link
  // ═══════════════════════════════════════════════════════════════════════
  headerMySettings: { en: 'My Settings', he: 'ההגדרות שלי' },

  // ═══════════════════════════════════════════════════════════════════════
  //  MySettingsPage — chrome
  // ═══════════════════════════════════════════════════════════════════════
  mySettingsTitle: { en: 'My Settings', he: 'ההגדרות שלי' },
  mySettingsIntro: {
    en: 'Personal preferences for how the portal looks and how you get notified — these apply only to you.',
    he: 'העדפות אישיות לגבי מראה הפורטל ואופן קבלת ההתראות — חלות עליך בלבד.',
  },

  // ═══════════════════════════════════════════════════════════════════════
  //  Appearance section (client-state only — langStore / layoutStore)
  // ═══════════════════════════════════════════════════════════════════════
  mySettingsAppearanceHeading: { en: 'Appearance', he: 'מראה' },
  mySettingsAppearanceDesc: {
    en: 'These are saved on this device/browser only.',
    he: 'הגדרות אלו נשמרות במכשיר/דפדפן זה בלבד.',
  },
  mySettingsLanguageLabel: { en: 'Language', he: 'שפה' },
  mySettingsLanguageEnglish: { en: 'English', he: 'אנגלית' },
  mySettingsLanguageHebrew: { en: 'Hebrew', he: 'עברית' },
  mySettingsLayoutLabel: { en: 'Console layout', he: 'פריסת הקונסולה' },
  mySettingsLayoutHelp: {
    en: 'How the Customer Chat and Bot Consultation panes are arranged in Live Conversations.',
    he: 'כיצד מסודרים חלוניות הצ׳אט עם הלקוח וייעוץ הבוט במסך השיחות הפעילות.',
  },

  // ═══════════════════════════════════════════════════════════════════════
  //  Notifications section (real API — notificationApi)
  // ═══════════════════════════════════════════════════════════════════════
  mySettingsNotifHeading: { en: 'Notifications', he: 'התראות' },
  mySettingsNotifDesc: {
    en: 'Choose which notifications you want to receive.',
    he: 'בחר אילו התראות ברצונך לקבל.',
  },
  mySettingsNotifLoading: { en: 'Loading notification preferences…', he: 'טוען העדפות התראות…' },
  mySettingsNotifLoadError: {
    en: 'Could not load your notification preferences.',
    he: 'לא ניתן היה לטעון את העדפות ההתראות שלך.',
  },
  mySettingsNotifSaveError: {
    en: 'Could not save this preference. Please try again.',
    he: 'לא ניתן היה לשמור העדפה זו. נסה שוב.',
  },
  mySettingsNotifSaved: { en: 'Saved', he: 'נשמר' },
  mySettingsNotifEmail: { en: 'Email notifications', he: 'התראות דוא״ל' },
  mySettingsNotifPush: { en: 'Push notifications', he: 'התראות דחיפה' },
  mySettingsNotifInApp: { en: 'In-app notifications', he: 'התראות בתוך האפליקציה' },
  mySettingsNotifSlaWarning: { en: 'SLA warning alerts', he: 'התראות אזהרת SLA' },
  mySettingsNotifSlaBreach: { en: 'SLA breach alerts', he: 'התראות חריגת SLA' },
  mySettingsNotifEscalation: { en: 'Escalation alerts', he: 'התראות הסלמה' },
  mySettingsNotifSystem: { en: 'System notifications', he: 'התראות מערכת' },
} satisfies Record<string, { en: string; he: string }>;
